var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002445(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.230469,
    y: 0.635742,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3606 11.5851L13.2005 25.486C12.9794 25.9136 13.2902 26.4246 13.772 26.4246H20.2667L18.8568 34.8903C18.7421 35.5827 19.274 36.2105 19.9768 36.2105C20.4127 36.2105 20.809 35.9623 20.9988 35.5702L27.8982 21.3105C28.1026 20.8892 27.8022 20.3991 27.335 20.3866L20.9237 20.226L22.5464 12.3547C22.6903 11.631 22.1355 10.9531 21.3972 10.9531C20.9592 10.9531 20.5587 11.1971 20.3606 11.5851Z",
    fill: "url(#paint0_linear_1352_1051)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1051",
    x1: 20.5457,
    y1: 10.9531,
    x2: 20.5457,
    y2: 36.2105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F54E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2995F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8312,
    height: 25.2595,
    fill: "white",
    transform: "translate(13.1274 10.9531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002445);
export default __webpack_public_path__ + "static/media/Group-1000002445.8feb31966c93a641ef459dc2f3ffdfd8.svg";
export { ForwardRef as ReactComponent };